import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';
import InputCheckbox from 'modules/_shared/components/InputCheckbox';
import movementTypes from 'modules/transactions/constants/movementTypes';
import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useRenumerationModal } from '../context/RenumerationModalContext';
import RangesView from './RangesView';

const ManualRenumerationMode: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useRenumerationModal();

  const isDisabledCheckbox =
    data.historyMovements.length > 0 || !data.selectedHoldingClassOption;

  const isDisabledClassSelector =
    (data.historyMovements.length > 0 &&
      data.historyMovements.some(
        (movement) =>
          movement.movementType === movementTypes.ENTIRE_CLASS_RENUMERATION
      )) ||
    data.reassignedRanges.length > 0;

  const showPagination = data.totalRanges > 5;

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="class-select-input">
          {t('SelectShareClassToFilter')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="class-select-input"
            value={data.selectedHoldingClassOption}
            onChange={actions.handleChangeHoldingClass}
            onFetchData={actions.handleSearchHoldingClass}
            placeholder={t('SearchClass')}
            minimumInputLength={1}
            noDataLabelKey="NoClassesHaveBeenFound"
            loadingLabelKey="LoadingClasses"
            errorLabelKey="ErrorLoadingClasses"
            defaultOptions={data.holdingClassOptions}
            isDisabled={isDisabledClassSelector}
            isClearable={false}
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="class-select-input">
          {t('SelectShareholderToFilter')}
        </label>
        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="partner-select-input"
            value={data.selectedPartnerOption}
            onChange={actions.handleChangePartner}
            onFetchData={actions.handleSearchPartner}
            placeholder={t('SearchPartner')}
            minimumInputLength={3}
            noDataLabelKey="NoPartnersHaveBeenFound"
            loadingLabelKey="LoadingPartners"
            errorLabelKey="ErrorLoadingPartners"
            defaultOptions={data.partnerOptions}
            isDisabled={data.isEntireClassRenumeration}
          />
        </div>
      </div>

      <div className="form-group">
        <InputCheckbox
          id="isEntireClassRenumeration"
          label={t('RenumerateEntireClass')}
          checked={data.isEntireClassRenumeration}
          onChange={actions.handleChangeIsEntireClassRenumeration}
          disabled={isDisabledCheckbox}
        />
      </div>

      <RangesView />

      {showPagination && (
        <div className="mt-1">
          <TablePagination
            totalRows={data.totalRanges}
            defaultRowsPerPage={data.rowsPerPage}
            onChangePage={actions.handleChangePage}
            onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          />
        </div>
      )}
    </>
  );
};

export default ManualRenumerationMode;
